import { USER_PROFILE_UPDATE_RECEIVED, FINISH_REGISTRATION, SET_VERIFICATION_RESPONSE } from './actionTypes/index';

/**
 * @description Sync action creator
 * @param data profile data(full, not just the diff)
 * @returns {{type, payload: *}} action object
 */
export const UserProfileUpdateReceived = (data) => ({
  type: USER_PROFILE_UPDATE_RECEIVED,
  payload: data,
});

export function FinishRegistration(payload) {
  return {
    type: FINISH_REGISTRATION,
    payload,
  };
}

export function SetVerificationResponse(payload) {
  return {
    type: SET_VERIFICATION_RESPONSE,
    payload,
  };
}